import React from "react";
import { GridColumn, GridContainer, GridRow } from "arv-reactcomponents";
import { OrderConfirmation } from "npmlinks-constants";
import PropTypes from "prop-types";
import LoyaltyBlock from "../LoyaltyBlock";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const orderUserInfo = (sentence, emailId, mobileNumber) =>
  sentence.replace("$mail", emailId).replace("$phoneNumber", mobileNumber);

const OrderConfirmStaticDetails = props => {
  const {
    emailId,
    mobileNumber,
    orderId,
    isStorePick,
    isDelivery,
  } = props.staticDetails;
  const { loyaltyPointsData } = props;

  return (
    <GridContainer className="nw-orderconfirm-static-container">
      <GridRow className="nw-orderconfirmstaticdetails-bannerrow">
        <GridColumn className="nw-orderconfirmstaticdetails-heading">
          <i className="icomoon-check nw-orderconfirm-checkicon" />
          <h2 className="nw-orderconfirm-static-text">{`${
            ORDERCONFIRMPAGE.SUB_TITLE_TEXT
          } #${orderId} !`}</h2>
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-5 nw-orderconfirm-order-info-bullets">
          <div className="nw-orderconfirmstaticdetails-bullets">
            <span className="nw-orderconfirm-static-bullets-padding">
              {orderUserInfo(
                ORDERCONFIRMPAGE.ORDER_USER_INFO,
                emailId,
                mobileNumber,
              )}
            </span>
            {isStorePick && (
              <span className="nw-orderconfirm-static-bullets-padding">
                {ORDERCONFIRMPAGE.ORDER_STOREPICK_INFO}
              </span>
            )}
            {isDelivery && (
              <span className="nw-orderconfirm-static-bullets-padding">
                {ORDERCONFIRMPAGE.ORDER_DELIVERY_INFO}
              </span>
            )}
          </div>
        </GridColumn>
        <GridColumn>
          {loyaltyPointsData && loyaltyPointsData.length !== 0 ? (
            <LoyaltyBlock.component loyaltyPointsData={loyaltyPointsData} />
          ) : null}
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

OrderConfirmStaticDetails.propTypes = {
  emailId: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  isStorePick: PropTypes.bool.isRequired,
  isDelivery: PropTypes.bool.isRequired,
  loyaltyPointsData: PropTypes.array.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderConfirmStaticDetails,
  component: OrderConfirmStaticDetails,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderConfirmStaticDetails/index.js